import React from 'react';
import { Button, Typography } from '@hpstellar/core/visId';

import useCartState from '../../../../hooks/useCartState';
import useUserData, { isCallCenter } from '../../../../hooks/useUserData';

const hasOOSSku = cartDetails => {
    const { orderitemIds } = cartDetails || {};
    return Object.values(orderitemIds || {}).some(({ invData }) => {
        return invData.inStock === '0';
    });
};

export default ({
    header,
    disabled,
    buttonProps = { children: 'Create Quote' },
    disclaimer = 'Create Quote to proceed with both in stock and out of stock products. You can convert your quote into an order once all products are in stock or back order.',
}) => {
    const { userData } = useUserData();
    const { profileData } = userData || {};
    const { personData } = profileData || {};
    const { customerLogonId } = personData || {};
    const { cartInfo } = useCartState();
    const { cartView, cartDetails } = cartInfo || {};
    const { x_checkoutUrl } = cartView || {};
    if (!isCallCenter(userData) || !customerLogonId) {
        return null;
    }
    if (disabled) {
        return null;
    }

    return (
        <>
            {header}
            <Button className="cc-btn" theme="dark" fullWidth={true} {...buttonProps} to={x_checkoutUrl} />
            <Typography className="checkout-disclaimer" variant="footnotes">
                {disclaimer}
            </Typography>
        </>
    );
};
